module.exports = __webpack_public_path__ + "img/235.carousel_door.5cdf9b7d.svg";